import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useSalesModel } from "../salesModel";

export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useSalesModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "客户名称",
            fieldName: "customerName",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "外贸合同号",
            fieldName: "code",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "单据状态",
            fieldName: "status",
            options: getSelectedDictOne(DictCodeEnmu.SALES)
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["制单起始日期", "制单结束日期"],
            // showTime: true,
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },
    ]

    return (
        <YhPageHeader
            title="外贸合同管理"
            size="small"
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}